"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./Chips.js");exports.Chips=e;exports.default=e;
//# sourceMappingURL=index.js.map
